import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { dentedRect } from '../utils/pathUtils'
import { scaleBand as d3_scaleBand } from 'd3-scale'

const MAX_BAR_WIDTH = 40
export default class BarChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * Orientation of the bars. When setting `horizontal: true` the x and y axes will be swapped.
     */
    horizontal: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    mode: {
      type: String,
      default: 'single',
      options: ['single', 'grouped', 'stacked'],
    },
    dataSorting: {
      type: [String],
      default: 'none',
      options: ['none', 'asc', 'desc'],
      exposed: true,
    },
    /**
     * Show the value on top of each bar.
     */
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    /**
     * Minimum height of each bar (in pixels).
     */
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    AxisHelper: {
      /**
       * Enable automatic scroll. If enabled, axes will be scrolalbel only if the number of bars is large enough.
       */
      zoom: {
        value: false,
      },
      x: {
        scale: {
          value: 'band',
          exposed: false,
        },
        getExtent: function (data) {
          if (this.config.mode === 'stacked') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else if (this.config.mode === 'grouped') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else return categoricalExtent(data) //return data.map((d)=>d.id)
        },
      },
      y: {
        side: 'left',
        getExtent: function (data) {
          let extent, extentParts
          if (this.config.mode === 'stacked') {
            extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          } else if (this.config.mode === 'grouped') {
            extentParts = continuousExtentParts(data)
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts) //d3.extent(data.reduce((res,d)=>res.concat(d3.extent(d.value,(dd)=>dd.value)),[]))
          } else {
            extentParts = data.map(d => ({ value: [d.value, d.value] })) //ESTABA MAL ESTOª!!!!! no?
            // console.log("extent parts",extentParts)
            extent = continuousExtent(data) //d3.extent(data,(d)=>d.value)
          }

          //Protect label!
          // let originalExtent = extent

          // extent = padLinear(extent,0.2)

          // NOT GOOD, porque se hace el padlinear luego, en el _setDomain
          // if(originalExtent[0]>=0) extent[0]=0
          // console.log("bar extent bef",extent)
          if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
            extent = cleanCollisions(this.axes.y, extent, extentParts)
          }
          // console.log("bar extent aft",extent)
          return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, AxisHelper]
  checkConsistency() {
    return true
  }
  draw() {
    let longDir, getTranslate, getOffset, getShort //,shortDir

    let barWidth, subBarWidth
    if (this.config.horizontal) {
      longDir = 'height'
      // shortDir = 'width'
      getTranslate = (long, short) => {
        return `translate(${short},${long})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      // getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      getOffset = v => {
        if (this.axes.y.func.scale().domain()[0] === 0)
          return Math.min(v, this.axes.y.func.scale()(offsetValue))
        else return this.axes.y.func.scale()(offsetValue)
      }
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
        // if (this.axes.y.func.scale().domain()[0] === 0 || val < 0) return Math.abs(val)
        // else return 1
      }
    } else {
      longDir = 'width'
      // shortDir = 'height'
      getTranslate = (long, short) => {
        return `translate(${long},${short})`
      }

      let offsetValue
      if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
        offsetValue = 0
      else offsetValue = this.axes.y.func.scale().domain()[0]

      getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
      // getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)
      getShort = v => {
        let val = this.axes.y.func.scale()(offsetValue) - v
        return Math.abs(val)
        // if (this.axes.y.func.scale().domain()[0] === 0 || val > 0) return Math.abs(val)
        // else return 1
      }
    }

    let barPercent = 0.7
    barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
    let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2

    let drawItem
    if (this.config.mode === 'stacked') {
      // hacemos que el stackpadding depenga de cada "stack": si es pequeño el stack, no ponemos padding
      // let stackPadding = 2
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          let l = getShort(this.axes.y.func.scale()(d.safeValue))
          let stackPadding = l < 10 ? 0 : 2
          if (status === 'enter' || status === 'exit') barPos = this.axes.y.func.scale()(0)
          else barPos = this.axes.y.func.scale()(this.config.horizontal ? d.y0 : d.y1)
          return getTranslate(
            this.axes.x.func.scale()(d.id) + barMargin,
            barPos + (this.config.horizontal ? 0 : stackPadding / 2)
          )
        })

        sel
          .select('path')
          .attr('fill', d => this.color({ id: d.parentId }))
          .attr('d', d => {
            let l = getShort(this.axes.y.func.scale()(d.safeValue))
            let stackPadding = l < 10 ? 0 : 2
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else
              barLength =
                getShort(this.axes.y.func.scale()(d.safeValue)) -
                (d.isFirstLayer ? stackPadding : stackPadding) //no tenia sentido hacerlos distinos, no!?

            barLength = Math.max(barLength, 0) //y le faltaba esto para cuando el "safeValue" da 0!!!
            let w = longDir === 'width' ? barWidth : barLength
            let h = longDir === 'width' ? barLength : barWidth
            return dentedRect(
              w,
              h,
              d.isLastLayer
                ? longDir === 'width'
                  ? 'tl'
                  : 'tr'
                : d.isFirstLayer
                ? longDir === 'width'
                  ? 'br'
                  : 'bl'
                : 'none'
            )
          })
      }
    } else if (this.config.mode === 'grouped') {
      barWidth = this.axes.x.scale.bandwidth() * barPercent
      barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2
      let subScale = d3_scaleBand()
        .domain(this.data.map(d => d.id))
        .range([barMargin, barMargin + barWidth]) //.range([w/2-w/6,w/2+w/3-w/6])
      let subBarPercent = 0.7
      // let subBarWidth = subScale.bandwidth()*subBarPercent
      // let subBarMargin = subScale.bandwidth()*(1-subBarPercent)/2
      subBarWidth = Math.min(MAX_BAR_WIDTH, subScale.bandwidth() * subBarPercent)
      let subBarMargin = (subScale.bandwidth() - subBarWidth) / 2
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          if (status === 'enter' || status === 'exit')
            barPos = getOffset(this.axes.y.func.scale()(0))
          else barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getTranslate(
            this.axes.x.func.scale()(d.id) + subScale(d.parentId) + subBarMargin,
            barPos
          )
        })

        sel
          .select('path')
          .attr('fill', d => this.color({ id: d.parentId }))
          .attr('d', d => {
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else barLength = getShort(this.axes.y.func.scale()(d.safeValue))
            let w = longDir === 'width' ? subBarWidth : barLength
            let h = longDir === 'width' ? barLength : subBarWidth
            let dent =
              longDir === 'width'
                ? d.safeValue > 0
                  ? ['tl', 'br']
                  : 'bl'
                : d.safeValue > 0
                ? ['bl', 'tr']
                : 'tr'

            let gap = null
            if (
              this.axes.y.func.scale().isChunky &&
              d.safeValue > this.axes.y.func.scale()._threshold
            ) {
              gap =
                this.axes.y.func.scale()(this.axes.y.func.scale()._threshold) -
                this.axes.y.func.scale()(d.safeValue)
            }

            return dentedRect(w, h, dent, gap)
          })
      }
    } else {
      drawItem = (sel, status) => {
        sel.attr('transform', d => {
          let barPos
          if (status === 'enter' || status === 'exit')
            barPos = getOffset(this.axes.y.func.scale()(0))
          else barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
          return getTranslate(this.axes.x.func.scale()(d.id) + barMargin, barPos)
        })
        sel
          .select('path')
          .attr('fill', d => this.color(d))
          .attr('d', d => {
            let barLength
            if (status === 'enter' || status === 'exit') barLength = 0
            else barLength = getShort(this.axes.y.func.scale()(d.safeValue))
            let w = longDir === 'width' ? barWidth : barLength
            let h = longDir === 'width' ? barLength : barWidth
            let dent =
              longDir === 'width'
                ? d.safeValue > 0
                  ? ['tl', 'br']
                  : 'bl'
                : d.safeValue > 0
                ? ['bl', 'tr']
                : 'tr'

            let gap = null
            if (
              this.axes.y.func.scale().isChunky &&
              d.safeValue > this.axes.y.func.scale()._threshold
            ) {
              gap =
                this.axes.y.func.scale()(this.axes.y.func.scale()._threshold) -
                this.axes.y.func.scale()(d.safeValue)
            }

            return dentedRect(w, h, dent, gap)
          })
      }
    }

    this.itemsEnter.append('path')

    // HAy que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
    this.itemsTrans.call(drawItem)
    this.itemsEnter.call(drawItem, 'enter')
    this.itemsEnterTrans.call(drawItem)
    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)

    let datumValues = this.itemsEnter
      .merge(this.items)
      .selectAll('.datum-value')
      .data(d => {
        if (this.config.showDatumValues) {
          if (this.config.mode === 'stacked') {
            if (d.isLastLayer) {
              //Excepcion (el safeVAlue este, para stacked+horizontal)...
              return [{ value: d.y1, safeValue: d.y1 - d.y0 }]
            } else {
              return []
            }
          } else {
            return [d]
          }
        } else {
          return []
        }
      })
    datumValues.exit().transition().style('opacity', 0).remove()
    datumValues = datumValues.merge(
      datumValues
        .enter()
        .append('text')
        .attr('class', 'datum-value')
        .style('opacity', 0)
        .style('font-size', '14px')
        .style('font-weight', 'bold')
        .attr('fill', 'currentColor')
    )
    datumValues
      .text(d => this.formatValue(d.value))
      // .text(d => this.valueWithUnit(d.value, 'y'))
      .transition()
      .style('opacity', 1)
    if (this.config.horizontal) {
      datumValues
        .attr('dominant-baseline', 'middle')
        .attr('text-anchor', 'start')
        .attr('y', 2 + (this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2))
        .attr('x', d => getShort(this.axes.y.func.scale()(d.safeValue)) + 8)
    } else {
      datumValues
        .attr('text-anchor', 'middle')
        .attr('x', this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2)
        .attr('y', -8)
    }

    // this.itemsEnter.append('text').attr('text-anchor', 'middle')
    // this.items
    //   .merge(this.itemsEnter)
    //   .select('text')
    //   // .text(d => this.formatValue(d.value, 'y'))
    //   .text(d => this.valueWithUnit(d.value, 'y'))
    //   .attr('x', this.config.mode === 'grouped' ? subBarWidth / 2 : barWidth / 2)
    //   .attr('y', -8)
  }
}
